export default __webpack_public_path__ + "static/media/saloon-v3-1104x828-30fps.af8f4b53.webm";